import { EDatasourceType } from "@kuika/kuika-cl-model";

export type TableEditorSqlDialect = "sqlserver" | "postgres" | "oracle";

export function resolveTableEditorSqlDialect(datasourceType?: EDatasourceType): TableEditorSqlDialect {
  if (datasourceType === EDatasourceType.ManagedDbPostgre || datasourceType === EDatasourceType.Postgre) {
    return "postgres";
  }
  if (datasourceType === EDatasourceType.ManagedDbOracle || datasourceType === EDatasourceType.Oracle) {
    return "oracle";
  }
  return "sqlserver";
}
